var PriceBarContainerState = /** @class */ (function () {
    function PriceBarContainerState() {
        this.cartState = {
            directToCheckout: false,
            dueMonthly: 0,
            dueOneTime: 0,
            dueToday: 0,
            enablepriceBarZeroAmount: false,
            isAmtProvidedTaxInclusive: false,
            readyToCheckout: false,
        };
        this.hideOneTimeCharges = false;
        this.isBBTVinCart = false;
        this.isApiCallInProgress = false;
        this.showACPModal = false;
    }
    return PriceBarContainerState;
}());
export default PriceBarContainerState;
//# sourceMappingURL=PriceBar.container.state.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/PriceBar/PriceBar.container.state.js
// module id = 1965
// module chunks = 8